// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#TopologyRenderer {
    flex-grow: 1;
}

#TopologyContainer {
    display: flex;
    max-height: 400px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Mininet/Topology/TopologyRenderer.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB","sourcesContent":["#TopologyRenderer {\n    flex-grow: 1;\n}\n\n#TopologyContainer {\n    display: flex;\n    max-height: 400px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
